import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const checkboxVariants = cva(
  "peer h-5 w-5 shrink-0 rounded-full border-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 group",
  {
    variants: {
      variant: {
        default: [
          "border-gray-300 dark:border-gray-600 hover:border-green-400 dark:hover:border-green-300",
          "data-[state=checked]:border-transparent data-[state=checked]:bg-green-500 dark:data-[state=checked]:bg-green-600 data-[state=checked]:text-white"
        ],
        blue: [
          "border-gray-300 dark:border-gray-600 hover:border-blue-400 dark:hover:border-blue-300",
          "data-[state=checked]:border-transparent data-[state=checked]:bg-blue-500 dark:data-[state=checked]:bg-blue-600 data-[state=checked]:text-white"
        ],
        purple: [
          "border-gray-300 dark:border-gray-600 hover:border-purple-400 dark:hover:border-purple-300",
          "data-[state=checked]:border-transparent data-[state=checked]:bg-purple-500 dark:data-[state=checked]:bg-purple-600 data-[state=checked]:text-white"
        ]
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
)

export interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
    VariantProps<typeof checkboxVariants> {}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, variant, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(checkboxVariants({ variant }), className)}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-3.5 w-3.5 stroke-[3]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
